'use client';

import { IconButton, Tooltip } from '@mui/material';
import { TbMoon, TbSun } from 'react-icons/tb';
import { useColorModeContext } from '@/components/providers';
export function ColorModeToggle({
  className
}) {
  const {
    isDark,
    toggleColorMode
  } = useColorModeContext();
  return <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
            <IconButton type="button" aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'} onClick={toggleColorMode} size="small" className={className} sx={{
      color: 'var(--foreground-muted)'
    }}>
                {isDark ? <TbSun className="size-5" /> : <TbMoon className="size-5" />}
            </IconButton>
        </Tooltip>;
}